<template>
  <div>
    <div class="text-center" style="padding: 2em 0 1em;">
      <img src="/static/imgs/logo.png"/>
    </div>

    <div id="formBox" class="panel panel-primary page">
      <div class="panel-heading">
        <span class="panel-title">Change Password</span>
      </div>

      <div v-if="checking" class="panel-body">
        <p class="text-muted" style="margin-bottom: 0;">Checking reset link&hellip;</p>
      </div>

      <template v-else-if="done">
        <div class="panel-body">
          <div class="alert alert-success" style="margin-bottom: 0;">
            <strong>Password updated.</strong>
            Your password has been changed. You can now sign in with your new password.
          </div>
        </div>
        <div class="panel-footer text-right">
          <a class="btn btn-primary" href="" @click.prevent="go_to_login">Go to login</a>
        </div>
      </template>

      <template v-else-if="invalid_reason">
        <div class="panel-body">
          <div class="alert alert-warning" style="margin-bottom: 0;">
            {{ invalid_message }}
          </div>
        </div>
        <div class="panel-footer text-right">
          <a class="btn btn-primary" href="" @click.prevent="go_to_login">Go to login</a>
          <a class="btn btn-warning" href="" @click.prevent="go_to_forgot">Request a new reset</a>
        </div>
      </template>

      <form v-else novalidate class="form-horizontal" role="form" @submit.prevent="send_reset">
        <div class="panel-body">
          <div class="form-group">
            <input type="password" v-model="password" class="form-control" placeholder="New Password"
                   :disabled="submitting">
          </div>
          <div class="form-group">
            <input type="password" v-model="password_confirm" class="form-control"
                   placeholder="Confirm Password" :disabled="submitting">
          </div>

          <div v-if="error" class="alert alert-danger" style="margin-bottom: 0;">
            {{ error }}
          </div>
        </div>

        <div class="panel-footer text-right">
          <button type="submit" class="btn btn-success" :disabled="submitting">
            {{ submitting ? "Saving..." : "Change Password" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>

</style>

<script>
  const INVALID_MESSAGE = "This reset link has expired or is no longer valid. Please request a new one.";

  export default {
    data() {
      return {
        password: "",
        password_confirm: "",
        error: "",
        checking: true,
        submitting: false,
        done: false,
        invalid_reason: "",
      }
    },
    computed: {
      invalid_message() {
        return INVALID_MESSAGE;
      },
      reset_id() {
        return this.$route.params.reset_id;
      },
    },
    async created() {
      await this.check_token();
    },
    methods: {
      async check_token() {
        this.checking = true;
        this.invalid_reason = "";
        try {
          const response = await this.$http.get("/api/reset/check/" + this.reset_id + "/");
          const body = await response.json();
          if (!response.ok || !body.valid) {
            this.invalid_reason = "expired";
          }
        } catch (_) {
          this.invalid_reason = "expired";
        } finally {
          this.checking = false;
        }
      },
      async send_reset() {
        if (this.submitting) {
          return;
        }
        this.error = "";
        this.submitting = true;

        try {
          const response = await this.$http.post("/api/reset/set/", {
            password: this.password,
            password_confirm: this.password_confirm,
            id: this.reset_id,
          });
          const req = await response.json();

          if (!response.ok) {
            this.error = req.error || "Something went wrong. Please try again.";
            if (response.status === 404) {
              this.invalid_reason = "expired";
              this.error = "";
            } else if (response.status === 400 && req.error && req.error.indexOf("expired") !== -1) {
              this.invalid_reason = "expired";
              this.error = "";
            }
            return;
          }

          if (req.success) {
            this.done = true;
            return;
          }

          this.error = req.error || "An unknown error occurred.";
        } catch (_) {
          this.error = "Something went wrong. Please try again.";
        } finally {
          this.submitting = false;
        }
      },
      go_to_login() {
        this.$router.push({name: "login"});
      },
      go_to_forgot() {
        this.$router.push({name: "reset-request"});
      },
    },
  }
</script>



// WEBPACK FOOTER //
// assets/vue/logger/PasswordReset.vue?4e5225a4